export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  // Exact match
  if (current === url) {
    return true
  }

  // Special case for root paths
  if (url === '/') {
    return current === url
  }

  // Special case for /orders - only highlight when exactly at /orders
  if (url === '/orders') {
    return current === '/orders'
  }

  // Split paths into segments
  const currentSegments = current.split('/').filter(Boolean)
  const urlSegments = url.split('/').filter(Boolean)

  // If URL has more segments than current path, it can't be active
  if (urlSegments.length > currentSegments.length) {
    return false
  }

  // For all other cases, compare all segments
  for (let i = 0; i < urlSegments.length; i++) {
    if (urlSegments[i] !== currentSegments[i]) {
      return false
    }
  }

  return true
}
